// src/layout/Dashboard/Drawer/DrawerContent/Navigation/index.jsx

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { getUserRole } from 'utils/auth';

// ==============================|| ROLE FILTER ||============================== //

const filterByRole = (items, role) => {
  if (!items) return [];

  return items
    .map((item) => {
      // kalau punya children, filter dulu anak-anaknya
      if (item.children && item.children.length) {
        const children = filterByRole(item.children, role);
        if (!children.length) return null; // semua anak ke-filter => group disembunyiin
        return { ...item, children };
      }

      // item tanpa "roles" => tampil untuk semua role
      if (!item.roles || item.roles.length === 0) return item;

      // item dengan "roles" => cek apakah role user ada di sana
      if (role && item.roles.includes(role)) return item;

      return null;
    })
    .filter(Boolean);
};

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

export default function Navigation() {
  const userRole = getUserRole() || 'user'; // default 'user' kalau belum kebaca

  // apply filter ke root items
  const filteredItems = filterByRole(menuItem.items, userRole);

  const navGroups = filteredItems.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;

      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
